declare global {
  interface Date {
    isSame(date: Date): boolean;
    isAfter(date: Date): boolean;
    isBefore(date: Date): boolean;
    isEqualOrAfter(date: Date): boolean;
    isEqualOrBefore(date: Date): boolean;
    isBetween(dateStart: Date, dateEnd: Date): boolean;
    addDays(days: number): Date;
    addMonths(months: number): Date;
    addYears(years: number): Date;
    withoutTimespan(): Date;
    withoutTimespan(): Date;
  }

  interface DateConstructor {
    min(...dates: Date[]): Date;
    max(...dates: Date[]): Date;
  }
}
Date.prototype.isSame = function (this: Date, date: Date): boolean {
  return this.getFullYear() == date.getFullYear() && this.getMonth() == date.getMonth() && this.getDate() == date.getDate();
};
Date.prototype.isAfter = function (this: Date, date: Date): boolean {
  return (
    this.getFullYear() > date.getFullYear() ||
    (this.getFullYear() == date.getFullYear() && this.getMonth() > date.getMonth()) ||
    (this.getFullYear() == date.getFullYear() && this.getMonth() == date.getMonth() && this.getDate() > date.getDate())
  );
};
Date.prototype.isBefore = function (this: Date, date: Date): boolean {
  return (
    this.getFullYear() < date.getFullYear() ||
    (this.getFullYear() == date.getFullYear() && this.getMonth() < date.getMonth()) ||
    (this.getFullYear() == date.getFullYear() && this.getMonth() == date.getMonth() && this.getDate() < date.getDate())
  );
};
Date.prototype.isEqualOrAfter = function (this: Date, date: Date): boolean {
  return this.isAfter(date) || this.isSame(date);
};
Date.prototype.isEqualOrBefore = function (this: Date, date: Date): boolean {
  return this.isBefore(date) || this.isSame(date);
};
Date.prototype.isBefore = function (this: Date, date: Date): boolean {
  return (
    this.getFullYear() < date.getFullYear() ||
    (this.getFullYear() == date.getFullYear() && this.getMonth() < date.getMonth()) ||
    (this.getFullYear() == date.getFullYear() && this.getMonth() == date.getMonth() && this.getDate() < date.getDate())
  );
};
Date.prototype.isBetween = function (this: Date, dateStart: Date, dateEnd: Date): boolean {
  return (this.isAfter(dateStart) || this.isSame(dateStart)) && (this.isBefore(dateEnd) || this.isSame(dateEnd));
};
Date.prototype.addDays = function (this: Date, days: number): Date {
  const date = new Date(this);
  return new Date(date.setDate(date.getDate() + days));
};
Date.prototype.addMonths = function (this: Date, months: number): Date {
  const date = new Date(this);
  return new Date(date.setMonth(date.getMonth() + months));
};
Date.prototype.addYears = function (this: Date, years: number): Date {
  const date = new Date(this);
  return new Date(date.setFullYear(date.getFullYear() + years));
};
Date.prototype.withoutTimespan = function (): Date {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0);
};

Date.min = function (...dates: Date[]): Date {
  return (dates ?? []).reduce<Date>((date, nextDate) => {
    return date ? (nextDate.isBefore(date) ? nextDate : date) : nextDate;
  }, null);
};
Date.max = function (...dates: Date[]): Date {
  return (dates ?? []).reduce<Date>((date, nextDate) => {
    return date ? (nextDate.isAfter(date) ? nextDate : date) : nextDate;
  }, null);
};

export {};
